import $ from 'jquery';
import Filter from './Filter';
import GoogleMapsLoader from 'google-maps';

// The search filter
export default class GeoFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    this.filterType = "GeoFilter";
    this.emptyValue = "";

    if($element.length <= 0) return false;

    $element.find('input').on('focus', this.geolocate);

    GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.KEY = 'AIzaSyA3AUzRF7_Og32sCYINzRlvqiMhlXWlu-M';
    GoogleMapsLoader.load((google) => {
        this.setupGeocoder(google);
    });

  }

  setupGeocoder(google) {
    let pac_input = this.$element.find('input').get(0);

    let options = {
      types: ['geocode'],
      componentRestrictions: {country: 'nl'}
    };

    (function pacSelectFirst(input) {
      // store the original event binding function
      let _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      function addEventListenerWrapper(type, listener) {
        console.log(type, input);
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type == "keydown" || type == "blur") {

          function orig_listener(event) {
            let suggestion_selected = $(".pac-item-selected").length > 0;
            let keyCode = event.keyCode || event.which;

            if ((keyCode === 13 || keyCode === 9) && !suggestion_selected) {
              let simulated_downarrow = $.Event("keydown", {
                keyCode: 40,
                which: 40
              });
              orig_listener.apply(input, [simulated_downarrow]);
            } else if(event.type === 'blur') {
              let firstResult;

              if($(".pac-container .pac-item:first span:eq(3)").text() == "") {
                firstResult = $(".pac-container .pac-item:first .pac-item-query").text();
              }
              else {
                firstResult = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();
              }

              let geocoder = new google.maps.Geocoder();
              geocoder.geocode({"address":firstResult }, function(results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                      placeName = results[0];
                      event.target.value = firstResult;
                      this.onChange(placeName);
                  }
              });
            }
            orig_listener.apply(input, [event]);
          };
        }

        // add the modified listener
        _addEventListener.apply(input, [type, listener]);
      }

      if (input.addEventListener)
        input.addEventListener = addEventListenerWrapper;
      else if (input.attachEvent)
        input.attachEvent = addEventListenerWrapper;

    })(pac_input);

    this.autocomplete = new google.maps.places.Autocomplete(pac_input);
    this.autocomplete.addListener('place_changed', this.onChange.bind(this));

  }

  geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        let geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    }
  }

  getValue(asObject = false) {

    let lastInstance = this.getLastUsedInstance();

    let data = {
      geo: lastInstance.find('input').data('geo'),
      lat: lastInstance.find('input').data('lat'),
      lng: lastInstance.find('input').data('lng')
    }

    // Return the value
    if(lastInstance.find('input').val() !== "" && data.geo && data.lat && data.lng) {
      // But first synchronize the other filters
      // for(let i = 0; i < window.WJP.query.getFilters(this.getKey()).length ; i++) {
      //   let filter = window.WJP.query.getFilters(this.getKey())[i];
      //
      //   if(filter !== this) {
      //      filter.setValue(data);
      //   }
      // }
      return asObject ? data : data.geo + '&lat=' + data.lat + '&lng=' + data.lng;
    }

    return null;
  }

  setValue( value ) {
    if(typeof value === "object") {
      this.$element.find('input').val(value.geo);
      this.$element.find('input').data('geo', value.geo);
      this.$element.find('input').data('lat', value.lat);
      this.$element.find('input').data('lng', value.lng);
    } else {
      this.$element.find('input').val(value);
    }
  }

  getKey() {
    return this.getElement().data('key') || this.getElement().data('wjp-filter-key');
  }

  onChange(place = null) {
    // Get the place details from the autocomplete object.
    place = (!place) ? this.autocomplete.getPlace() : place;

    if(place && place.geometry) {
      this.$element.find('input').data('lat', place.geometry.location.lat());
      this.$element.find('input').data('lng', place.geometry.location.lng());
      this.$element.find('input').data('geo', place.formatted_address);
    }

    this.setLastUsedInstance();

    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: this.getValue(),
      sender: this
    });
  }

  setLastUsedInstance() {
    window.WJP.GeoFilterInstance = this.$element;
  }

  getLastUsedInstance() {
    return window.WJP.GeoFilterInstance || this.$element;
  }

};



/** WEBPACK FOOTER **
 ** ../assets/js/filters/GeoFilter.js
 **/